// Admin — continuous catalog ingestion (supabase/migrations/20261020014800_market_ingestion.sql).
// One status call for the dashboard; every change goes through an
// admin_market_ingest_* RPC, which checks the role and logs the change.
import { marketRpc } from './marketDb';

export const ingestStatus = () => marketRpc('admin_market_ingest_status', {});
// The daily Gemini cap across every caller (migration ai_budget): today by lane and by function.
export const aiBudget = async () => { const r = await marketRpc('admin_ai_budget', {}); return r.ok ? r.data : null; };
export const aiBudgetUpdate = (patch) => marketRpc('admin_ai_budget_update', { p_patch: patch });
export const ingestSettings = (patch) => marketRpc('admin_market_ingest_settings_update', { p_patch: patch });
/** 'pause' | 'resume' | 'stop' | 'release' | 'schedule' */
export const ingestControl = (action) => marketRpc('admin_market_ingest_control', { p_action: action });
export const ingestRetry = (jobId) => marketRpc('admin_market_ingest_retry', { p_job_id: jobId });

/** The budget fields the dashboard edits, with their Arabic / English labels and units. */
export const BUDGET_FIELDS = [
  ['daily_budget_usd', 'الحد اليومي الإجمالي', 'Overall daily limit', 'USD'],
  ['monthly_budget_usd', 'الحد الشهري الإجمالي', 'Overall monthly limit', 'USD'],
  ['hiobuy_units_day', 'وحدات HioBuy يوميًا', 'HioBuy units per day', 'units'],
  ['hiobuy_units_month', 'وحدات HioBuy شهريًا', 'HioBuy units per month', 'units'],
  ['hiobuy_usd_per_unit', 'تكلفة الوحدة لدى HioBuy', 'HioBuy cost per unit', 'USD'],
  ['gemini_usd_day', 'Gemini يوميًا', 'Gemini per day', 'USD'],
  ['gemini_usd_month', 'Gemini شهريًا', 'Gemini per month', 'USD'],
  ['est_gemini_usd_import', 'تقدير Gemini لكل منتج', 'Gemini estimate per import', 'USD'],
  ['warn_pct', 'نسبة التنبيه', 'Warn at', '0–1'],
  ['pause_pct', 'نسبة الإيقاف التلقائي', 'Auto-pause at', '0–1'],
];
export const PACE_FIELDS = [
  ['max_concurrency', 'المهام المتزامنة', 'Concurrent jobs', ''],
  ['jobs_per_run', 'المهام في كل دورة', 'Jobs per run', ''],
  ['discovery_share', 'حصة الاكتشاف من كل دورة', 'Discovery share of each run', '0–1'],
  ['per_type_per_day', 'منتجات جديدة لكل نوع يوميًا', 'New products per type per day', ''],
  ['sync_max_age_hours', 'أقصى عمر للتحديث', 'Re-sync after', 'hours'],
];
